webpackJsonp([1],{

/***/ "/gHy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3+j1":
/***/ (function(module, exports) {

/*eslint-disable */
var define = window.define || ace.define;

define('mode/markddrive', function (require, exports, module) {

  var oop = require("ace/lib/oop");
  var MarkdownMode = require("ace/mode/markdown").Mode;
  var PythonMode = require("ace/mode/python").Mode;
  var PHPMode = require("ace/mode/php").Mode;
  var RubyMode = require("ace/mode/ruby").Mode;
  var MarkdDriveHighlightRules = require("markddrive_highlight_rules").MarkdDriveHighlightRules;

  var Mode = function Mode() {
    this.HighlightRules = MarkdDriveHighlightRules;

    this.createModeDelegates({
      "python-": PythonMode,
      "php-": PHPMode,
      "ruby-": RubyMode
    });

    this.$behaviour = this.$defaultBehaviour;
  };
  oop.inherits(Mode, MarkdownMode);

  (function () {
    // Extra logic goes here. (see below)
  }).call(Mode.prototype);

  exports.Mode = Mode;
});

define('markddrive_highlight_rules', function (require, exports, module) {

  var oop = require("ace/lib/oop");
  var MarkdownHighlightRules = require("ace/mode/markdown_highlight_rules").MarkdownHighlightRules;
  var PHPHighlightRules = require("ace/mode/php_highlight_rules").PhpHighlightRules;
  var PythonHighlightRules = require("ace/mode/python_highlight_rules").PythonHighlightRules;
  var RubyHighlightRules = require("ace/mode/ruby_highlight_rules").RubyHighlightRules;

  function github_embed(tag, prefix) {
    return { // Github style block
      token: "support.function",
      regex: "^\\s*```" + tag + "\\s*$",
      push: prefix + "start"
    };
  }

  var MarkdDriveHighlightRules = function MarkdDriveHighlightRules() {

    this.$rules = new MarkdownHighlightRules().getRules();

    var unnumeredListRule = { // unnumbered list
      token: function token(indent, list_item) {
        var tabSize = window._session.getTabSize();
        return ["markup.list", "markup.list.unnumbered.level_" + indent.length / tabSize];
      },
      regex: "^(\\s{0,})([*+-]\\s+)",
      next: "listblock-start"
    };
    var numberedListRule = { // numbered list
      token: function token(indent, list_item) {
        var tabSize = window._session.getTabSize();
        return ["markup.list", "markup.list.numbered.level_" + indent.length / tabSize];
      },
      regex: "^(\\s{0,})(\\d+\\.\\s+)",
      next: "listblock-start"
    };

    this.$rules["start"].unshift(github_embed("php", "phpcode-"), github_embed("python", "pythoncode-"), github_embed("ruby", "rubycode-"), unnumeredListRule, numberedListRule);

    this.addRules({
      "listblock": [{ // Lists only escape on completely blank lines.
        token: "empty_line",
        regex: "^$",
        next: "start"
      }, unnumeredListRule, numberedListRule, {
        include: "basic", noEscape: true
      }, { // Github style block
        token: "support.function",
        regex: "^\\s*```\\s*[a-zA-Z]*(?:{.*?\\})?\\s*$",
        next: "githubblock"
      }, {
        defaultToken: "list" //do not use markup.list to allow stling leading `*` differntly
      }]
    });

    this.embedRules(PHPHighlightRules, "phpcode-", [{
      token: "support.function",
      regex: "^\\s*```",
      next: "pop"
    }]);

    this.embedRules(PythonHighlightRules, "pythoncode-", [{
      token: "support.function",
      regex: "^\\s*```",
      next: "pop"
    }]);

    this.embedRules(RubyHighlightRules, "rubycode-", [{
      token: "support.function",
      regex: "^\\s*```",
      next: "pop"
    }]);

    this.normalizeRules();
  };

  oop.inherits(MarkdDriveHighlightRules, MarkdownHighlightRules);

  exports.MarkdDriveHighlightRules = MarkdDriveHighlightRules;
});
/*eslint-enable */

/***/ }),

/***/ "7YgM":
/***/ (function(module, exports) {

module.exports = {"name":"markddrive","version":"0.6.0","description":"A simple markdown editor synchronized with google drive.","homepage":"https://gitlab.florian-perrot.fr/lheido/MarkdDrive","bugs":{"url":"https://gitlab.florian-perrot.fr/lheido/MarkdDrive/issues"},"license":"GNU GPLv3","author":"\"lheido\" <\"leonard.treille@gmail.com\">","private":false,"scripts":{"dev":"node build/dev-server.js","start":"node build/dev-server.js","build":"node build/build.js && docker rmi markddrive-build && docker build -t markddrive-build .","lint":"eslint --ext .js,.vue src","drun":"docker run --rm -p 8080:80 markddrive-build","push-latest":"docker push ltreille/markddrive:latest"},"dependencies":{"ace-builds":"^1.2.8","remarkable":"^1.7.1","underscore":"latest","vue":"^2.4.2","vue-events":"^3.0.1","vue-material":"^0.7.4"},"devDependencies":{"autoprefixer":"^7.1.2","babel-core":"^6.22.1","babel-eslint":"^7.1.1","babel-loader":"^7.1.1","babel-plugin-transform-runtime":"^6.22.0","babel-preset-env":"^1.3.2","babel-preset-stage-2":"^6.22.0","babel-register":"^6.22.0","chalk":"^2.0.1","connect-history-api-fallback":"^1.3.0","copy-webpack-plugin":"^4.0.1","css-loader":"^0.28.0","cssnano":"^3.10.0","eslint":"^3.19.0","eslint-config-airbnb-base":"^11.1.3","eslint-friendly-formatter":"^3.0.0","eslint-import-resolver-webpack":"^0.8.1","eslint-loader":"^1.7.1","eslint-plugin-html":"^3.0.0","eslint-plugin-import":"^2.2.0","eventsource-polyfill":"^0.9.6","express":"^4.14.1","extract-text-webpack-plugin":"^2.0.0","file-loader":"^0.11.1","friendly-errors-webpack-plugin":"^1.1.3","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.3","node-sass":"^4.5.3","opn":"^5.1.0","optimize-css-assets-webpack-plugin":"^2.0.0","ora":"^1.2.0","rimraf":"^2.6.0","sass-loader":"^6.0.6","semver":"^5.3.0","shelljs":"^0.7.6","url-loader":"^0.5.8","vue-loader":"^13.0.4","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^2.6.1","webpack-bundle-analyzer":"^2.2.1","webpack-dev-middleware":"^1.10.0","webpack-hot-middleware":"^2.18.0","webpack-merge":"^4.1.0"},"engines":{"node":">= 4.0.0","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),

/***/ "8yQe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AUqH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * @from https://github.com/tralves/vue-gdrive/blob/master/src/gapi/multipart.js
 * Thank to the authors of vue-gdrive.
 */
/*eslint-disable */
/**
 * Helper for building multipart requests for uploading to Drive.
 */
var _class = function () {
  function _class() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.boundary = Math.random().toString(36).slice(2);
    this.mimeType = 'multipart/mixed; boundary="' + this.boundary + '"';
    this.parts = [];
    this.body = null;
  }

  /**
   * Appends a part.
   *
   * @param {String} mimeType Content type of this part
   * @param {Blob|File|String} content Body of this part
   */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'append',
    value: function append(mimeType, content) {
      if (this.body !== null) {
        throw new Error('Builder has already been finalized.');
      }
      this.parts.push('\r\n--', this.boundary, '\r\n', 'Content-Type: ', mimeType, '\r\n\r\n', content);
      return this;
    }

    /**
     * Finalizes building of the multipart request and returns a Blob containing
     * the request. Once finalized, appending additional parts will result in an
     * error.
     *
     * @returns {Object} Object containing the mime type (mimeType) & assembled multipart body (body)
     */

  }, {
    key: 'finish',
    value: function finish() {
      if (this.parts.length === 0) {
        throw new Error('No parts have been added.');
      }
      if (this.body === null) {
        this.parts.push('\r\n--', this.boundary, '--');
        this.body = this.parts.join('');
        // TODO - switch to blob once gapi.client.request allows it
        // this.body = new Blob(this.parts, {type: this.mimeType});
      }
      return {
        type: this.mimeType,
        body: this.body
      };
    }
  }]);

  return _class;
}();
/*eslint-enable */


/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),

/***/ "AuQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'driveFileListItem',

  props: ['file'],

  data: function data() {
    return {
      parents: [],
      /**
       * save, create, delete status.
       * Each status value may be:
       *   - ''
       *   - 'pending'
       *   - 'success' (saveStatus only)
       *   - 'error'
       */
      saveStatus: '',
      createStatus: '',
      deleteStatus: ''
    };
  },


  computed: {
    computedParents: function computedParents() {
      if (this.parents && this.parents.length > 0) {
        return this.parents.reverse().join(' / ');
      }
      return '';
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.parents = [];
    this.createStatus = '';
    this.saveStatus = '';
    this.deleteStatus = '';
    if (this.file.parents && this.file.parents.length > 0) {
      this.getParents(this.file.parents);
    }
    this.$events.on('editor-pending-save', function (file, pending, response) {
      if (file.id === _this.file.id) {
        _this.saveStatus = pending ? 'pending' : '';
        if (response) {
          _this.saveStatus = response.status === 200 ? 'success' : 'error';
        }
      }
    });
  },


  methods: {
    getParents: function getParents() {
      var _this2 = this;

      var parentIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      parentIds.forEach(function (parentId) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].googleDrive.file(parentId).then(function (response) {
          if (response.status === 200 && response.result) {
            _this2.parents.push(response.result.name);
            if (response.result.parents && response.result.parents.length > 0) {
              _this2.getParents(response.result.parents);
            }
          }
        });
      });
    },
    createFile: function createFile() {
      var _this3 = this;

      if (this.file.name !== '') {
        this.createStatus = 'pending';
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].googleDrive.saveFile(this.file, '# ' + this.file.name).then(function (response) {
          if (response.status === 200) {
            _this3.createStatus = '';
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this3.file, response.result);
            _this3.file.isNew = false;
            _this3.parents = [];
            _this3.getParents(_this3.file.parents);
          } else {
            _this3.createStatus = 'error';
          }
        });
      }
    },
    triggerEditFile: function triggerEditFile() {
      this.file.isNew = undefined;
      this.$events.emit('edit-file', this.file);
    },
    deleteFile: function deleteFile() {
      var _this4 = this;

      this.deleteStatus = 'pending';
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].googleDrive.delete(this.file.id).then(function (response) {
        if (response.status === 204) {
          _this4.$events.emit('file-delete', _this4.file);
        } else {
          _this4.deleteStatus = 'error';
        }
      });
    }
  }
});

/***/ }),

/***/ "BV6F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * Install plugin.
   * @param Vue
   * @param options
   *   Options is an object like:
   *     - debug
   */
  install: function install(Vue, options) {
    /*eslint-disable */
    Vue.debug = options.debug || false;

    new Vue({
      created: function created() {
        this.$events.on('log', function (status) {
          var _console;

          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          (_console = console).log.apply(_console, [status].concat(args));
        });
      }
    });

    /*eslint-enable */

    Vue.mixin({
      methods: {
        get debug() {
          return Vue.debug;
        },

        /**
         * Allow component to log message.
         * Allow other plugin to take into account of this log with a log
         * event.
         * @param {string} status
         *   Status may be:
         *     - 'status'
         *     - 'error'
         *     - 'debug'
         *     - or any other status taken into account by plugin that listen
         *     to the log event.
         * @param args
         */
        log: function log(status) {
          if (Vue.debug) {
            var _$events;

            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (_$events = this.$events).emit.apply(_$events, ['log', status].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
          }
        }
      }
    });
  }
});

/***/ }),

/***/ "ENgG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "driveFileList"
    }
  }, [_c('md-toolbar', [_c('md-input-container', {
    staticClass: "filter",
    staticStyle: {
      "flex": "1"
    }
  }, [_c('label', [_vm._v("Filter")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.create
    }
  }, [_c('md-icon', [_vm._v("add")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom"
    }
  }, [_vm._v("Create new file")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.refresh
    }
  }, [_c('md-icon', {
    staticClass: "status-icon md-primary",
    class: {
      'pending': _vm.refreshStatus === 'pending'
    }
  }, [_vm._v("refresh")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom"
    }
  }, [_vm._v("Refresh the file list")])], 1)], 1), _vm._v(" "), _c('md-list', {
    staticClass: "md-double-line file-list"
  }, _vm._l((_vm.filteredFiles), function(file) {
    return _c('DriveFileListItem', {
      key: file.id,
      attrs: {
        "file": file
      }
    })
  }))], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GAZN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriveFileList_vue__ = __webpack_require__("n3y4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c46823d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DriveFileList_vue__ = __webpack_require__("ENgG");
function injectStyle (ssrContext) {
  __webpack_require__("/gHy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c46823d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriveFileList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c46823d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DriveFileList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4daf91f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("zZsU");
function injectStyle (ssrContext) {
  __webpack_require__("c69N")
  __webpack_require__("e+lD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4daf91f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4daf91f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Msg3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_remarkable__ = __webpack_require__("OVoi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_remarkable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_remarkable__);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'remarkable',

  props: ['value'],

  data: function data() {
    return {};
  },

  computed: {
    compiledMarkdown: function compiledMarkdown() {
      return new __WEBPACK_IMPORTED_MODULE_0_remarkable___default.a('full').render(this.value);
    }
  },
  methods: {}
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material__ = __webpack_require__("Lgyv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_events__ = __webpack_require__("EZrF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css__ = __webpack_require__("tzNG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_debug_debug__ = __webpack_require__("BV6F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_google_drive_google_drive__ = __webpack_require__("evU7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__("M93x");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_events___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__plugins_debug_debug__["a" /* default */], { debug: true });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__plugins_google_drive_google_drive__["a" /* default */], {
  client_id: '68467411263-ukrdou4cvadnak2r0pe1f4nosvjfm6np.apps.googleusercontent.com'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].material.registerTheme('default', {
  accent: 'teal',
  warn: 'red'
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */] }
});

/***/ }),

/***/ "VUfz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', [(_vm.file.isNew) ? [_c('div', {
    staticClass: "md-list-text-container"
  }, [_c('md-input-container', [_c('label', [_vm._v("File Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": "",
      "autofocus": ""
    },
    model: {
      value: (_vm.file.name),
      callback: function($$v) {
        _vm.file.name = $$v
      },
      expression: "file.name"
    }
  })], 1)], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    staticStyle: {
      "flex": "0"
    },
    on: {
      "click": _vm.createFile
    }
  }, [(_vm.createStatus === '') ? _c('md-icon', {
    staticClass: "status-icon md-primary"
  }, [_vm._v("done")]) : _vm._e(), _vm._v(" "), (_vm.createStatus === 'pending') ? _c('md-icon', {
    staticClass: "status-icon md-primary pending"
  }, [_vm._v("refresh")]) : _vm._e(), _vm._v(" "), (_vm.createStatus === 'error') ? _c('md-icon', {
    staticClass: "status-icon md-primary error"
  }, [_vm._v("error")]) : _vm._e()], 1)] : [_c('md-button', {
    staticClass: "md-icon-button md-list-action delete-btn",
    class: {
      error: _vm.deleteStatus === 'error'
    },
    staticStyle: {
      "flex": "0"
    },
    on: {
      "click": _vm.deleteFile
    }
  }, [(_vm.deleteStatus === 'pending') ? _c('md-icon', {
    staticClass: "status-icon md-primary pending"
  }, [_vm._v("refresh")]) : _c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("delete")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.file.name))]), _vm._v(" "), _c('span', {
    staticClass: "parents"
  }, [_vm._v(_vm._s(_vm.computedParents))])]), _vm._v(" "), (_vm.saveStatus === 'pending') ? _c('md-icon', {
    staticClass: "md-primary status-icon pending"
  }, [_vm._v("refresh")]) : _vm._e(), _vm._v(" "), (_vm.saveStatus === 'success') ? _c('md-icon', {
    staticClass: "md-primary status-icon success"
  }, [_vm._v("cloud_done")]) : _vm._e(), _vm._v(" "), (_vm.saveStatus === 'error') ? _c('md-icon', {
    staticClass: "md-primary status-icon error"
  }, [_vm._v("error")]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    staticStyle: {
      "flex": "0"
    },
    on: {
      "click": _vm.triggerEditFile
    }
  }, [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("edit")])], 1)]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XGaa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "remarkable"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compiledMarkdown)
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZaTb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "aceWrapper",
    staticClass: "ace-wrapper"
  }, [_c('div', {
    staticClass: "ace-editor",
    attrs: {
      "id": "ace-editor"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aek+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__ = __webpack_require__("pIzI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54f2f2ed_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__ = __webpack_require__("hMxL");
function injectStyle (ssrContext) {
  __webpack_require__("8yQe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54f2f2ed"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54f2f2ed_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bTBT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriveFileListItem_vue__ = __webpack_require__("AuQF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6bedc7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DriveFileListItem_vue__ = __webpack_require__("VUfz");
function injectStyle (ssrContext) {
  __webpack_require__("rO5K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b6bedc7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriveFileListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6bedc7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DriveFileListItem_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c69N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e+lD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "evU7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__multipart__ = __webpack_require__("AUqH");




/**
 * Google drive api plugin.
 */

/*eslint-disable */


var GoogleDrivePlugin = function () {
  function GoogleDrivePlugin(options) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, GoogleDrivePlugin);

    this.observers = {};

    var CLIENT_ID = options.client_id;
    var auto_login = options.auto_login || false;
    // Array of API discovery doc URLs for APIs used by the quickstart
    var DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'];
    // Authorization scopes required by the API; multiple scopes can be
    // included, separated by spaces.
    var SCOPES = 'https://www.googleapis.com/auth/drive';

    gapi.load('client:auth2', function () {
      gapi.client.init({
        discoveryDocs: DISCOVERY_DOCS,
        clientId: CLIENT_ID,
        scope: SCOPES
      }).then(function () {
        var isSignedIn = _this.isSignIn;
        _this.notify('gapi.auth2:loaded', isSignedIn);
        // Listen for sign-in state changes.
        if (!isSignedIn) {
          gapi.auth2.getAuthInstance().isSignedIn.listen(function () {
            _this.notify('isSignInChanged', _this.isSignIn);
          });
          if (_this.auto_login) {
            _this.signIn();
          }
        }
      });
    });

    gapi.load('picker', { 'callback': function callback() {
        _this.notify('picker:loaded');
      } });
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(GoogleDrivePlugin, [{
    key: 'signIn',
    value: function signIn() {
      try {
        return gapi.auth2.getAuthInstance().signIn();
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'signOut',
    value: function signOut() {
      try {
        return gapi.auth2.getAuthInstance().signOut();
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'file',
    value: function file(id) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '*';

      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      return gapi.client.drive.files.get(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        fileId: id,
        fields: fields
      }, args));
    }
  }, {
    key: 'fileContent',
    value: function fileContent(id) {
      return gapi.client.drive.files.get({
        fileId: id,
        alt: 'media'
      });
    }
  }, {
    key: 'files',
    value: function files() {
      var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'name contains \'.md\'';
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "files(id, name, parents)";

      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return gapi.client.drive.files.list(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        q: q,
        fields: fields
      }, args));
    }
  }, {
    key: 'saveFile',
    value: function saveFile(file, content) {
      var path = void 0;
      var method = void 0;

      if (file.id) {
        path = '/upload/drive/v3/files/' + encodeURIComponent(file.id);
        method = 'PATCH';
      } else {
        path = '/upload/drive/v3/files';
        method = 'POST';
      }

      var metadata = {
        mimeType: file.mimeType || 'text/markdown',
        name: file.name
      };

      var multipart = new __WEBPACK_IMPORTED_MODULE_4__multipart__["a" /* default */]().append('application/json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(metadata)).append(metadata.mimeType, content).finish();
      return gapi.client.request({
        path: path,
        method: method,
        params: {
          uploadType: 'multipart',
          fields: '*'
        },
        headers: { 'Content-Type': multipart.type },
        body: multipart.body
      });
    }
  }, {
    key: 'delete',
    value: function _delete(fileId) {
      return gapi.client.request({
        path: '/drive/v3/files/' + fileId,
        method: 'DELETE'
      });
    }
  }, {
    key: 'on',
    value: function on(event, func) {
      if (this.observers[event] === undefined) {
        this.observers[event] = [];
      }
      this.observers[event].push(func);
    }
  }, {
    key: 'notify',
    value: function notify(event) {
      if (this.observers[event] !== undefined) {
        for (var _len3 = arguments.length, params = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          params[_key3 - 1] = arguments[_key3];
        }

        for (var i in this.observers[event]) {
          var _observers$event;

          (_observers$event = this.observers[event])[i].apply(_observers$event, params);
        }
      }
    }
  }, {
    key: 'isSignIn',
    get: function get() {
      return gapi.auth2.getAuthInstance().isSignedIn.get();
    }
  }, {
    key: 'user',
    get: function get() {
      return gapi.auth2.getAuthInstance().currentUser.get();
    }
  }]);

  return GoogleDrivePlugin;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * Install plugin.
   * @param Vue
   * @param options
   *   Options is an object like:
   *     - client_id
   */
  install: function install(Vue, options) {
    var googleDrive = new GoogleDrivePlugin(options);
    Vue.googleDrive = googleDrive;
  }
});
/*eslint-enable */

/***/ }),

/***/ "hFta":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hMxL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "editor"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        if (!$event.ctrlKey) { return null; }
        _vm.toggleRemarkable($event)
      }
    }
  }, [_c('Ace', {
    ref: "ace",
    attrs: {
      "value": _vm.value
    },
    on: {
      "change": _vm.onDocumentChanged,
      "slow-change": _vm.saveDocument
    }
  }), _vm._v(" "), _c('MarkdownToHtml', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.remarkableIsVisible),
      expression: "remarkableIsVisible"
    }],
    attrs: {
      "value": _vm.currentValue
    }
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-fab toggle-remarkable",
    on: {
      "click": _vm.toggleRemarkable
    }
  }, [(_vm.remarkableIsVisible) ? _c('md-icon', [_vm._v("visibility_off")]) : _c('md-icon', [_vm._v("visibility")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j9aK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("rdLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ace_builds_src_min_noconflict_ace__ = __webpack_require__("xjBu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ace_builds_src_min_noconflict_ace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ace_builds_src_min_noconflict_ace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ace_builds_src_min_noconflict_ext_language_tools__ = __webpack_require__("mKw/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ace_builds_src_min_noconflict_ext_language_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ace_builds_src_min_noconflict_ext_language_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ace_builds_src_min_noconflict_mode_markdown__ = __webpack_require__("S4P4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ace_builds_src_min_noconflict_mode_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ace_builds_src_min_noconflict_mode_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ace_builds_src_min_noconflict_mode_python__ = __webpack_require__("Szhv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ace_builds_src_min_noconflict_mode_python___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ace_builds_src_min_noconflict_mode_python__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ace_builds_src_min_noconflict_mode_php__ = __webpack_require__("D/ch");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ace_builds_src_min_noconflict_mode_php___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ace_builds_src_min_noconflict_mode_php__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ace_builds_src_min_noconflict_mode_ruby__ = __webpack_require__("SKTc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ace_builds_src_min_noconflict_mode_ruby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ace_builds_src_min_noconflict_mode_ruby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ace_custom_mode_markddrive__ = __webpack_require__("3+j1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ace_custom_mode_markddrive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ace_custom_mode_markddrive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ace_custom_theme_markddrive__ = __webpack_require__("tJhk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ace_custom_theme_markddrive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ace_custom_theme_markddrive__);
//
//
//
//
//
//













var TokenIterator = window.ace.require('ace/token_iterator').TokenIterator;
var Range = window.ace.require('ace/range').Range;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ace',

  props: ['value'],

  data: function data() {
    return {
      isReady: false
    };
  },


  watch: {
    value: function value() {
      this.init();
      this.isFirstChange = true;
      this.editor.getSession().off('slow-change');
      this.editor.setValue(this.value);
      this.editor.clearSelection();
      this.editor.gotoLine(0);
      // Reset undo manager to avoid first setValue.
      this.editor.getSession().setUndoManager(new window.ace.UndoManager());
      this.focus();
    }
  },

  methods: {
    createAceContainer: function createAceContainer() {
      var newAceEditorElement = document.createElement('div');
      newAceEditorElement.setAttribute('id', 'ace-editor');
      newAceEditorElement.classList.add('ace-editor');
      return newAceEditorElement;
    },
    destroy: function destroy() {
      if (this.editor) {
        this.editor.destroy();
        while (this.$refs.aceWrapper.firstChild) {
          this.$refs.aceWrapper.removeChild(this.$refs.aceWrapper.firstChild);
        }
        this.editor = undefined;
        var newAceEditorElement = this.createAceContainer();
        this.$refs.aceWrapper.appendChild(newAceEditorElement);
      }
    },
    init: function init() {
      /*eslint-disable */
      if (this.editor) {
        this.destroy();
      }
      this.isFirstChange = true;
      this.editor = window.ace.edit('ace-editor');
      this.editor.setTheme("theme/markddrive");
      this.editor.setBehavioursEnabled(true);
      this.editor.setShowPrintMargin(false);
      this.editor.setOptions({
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: false,
        scrollPastEnd: true
      });

      //disable message from ace.
      this.editor.$blockScrolling = Infinity;

      this.editor.on('mouseup', this.onMouseUp);

      var indent_list_regex = /^markup\.list/;

      this.editor.commands.addCommand({
        name: 'indent_list',
        bindKey: { win: "Tab", mac: "Tab" },
        exec: function exec(editor) {
          var selection = editor.session.getSelection();
          // If multiple lines are selected then call default indent behavior.
          if (selection.anchor.row !== selection.lead.row) {
            editor.indent();
          } else {
            var pos = editor.getCursorPosition();
            var token = editor.session.getTokenAt(pos.row, pos.column);
            if (indent_list_regex.test(token.type)) {
              editor.gotoLine(pos.row + 1, 0);
              editor.indent();
              editor.gotoLine(pos.row + 1, pos.column + editor.session.getTabSize());
            } else {
              editor.indent();
            }
          }
        },
        multiSelectAction: "forEach",
        scrollIntoView: "selectionPart"
      });
      this.editor.commands.addCommand({
        name: 'clean_list',
        bindKey: { win: "Ctrl+Shift+E", mac: "Cmd+Shift+E" },
        exec: function (editor) {
          var _this = this;

          var iterator = new TokenIterator(editor.session, 0, 0);
          var lists = this.buildListTree(iterator);
          lists.forEach(function (list) {
            _this.cleanNumberedList(editor, list);
          });
        }.bind(this)
      });

      this.session = this.editor.getSession();
      window._session = this.session;
      this.session.setMode("mode/markddrive");
      this.session.on('change', __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.debounce(this.onDocumentChanged, 500));
      this.isReady = true;
      /*eslint-enable */
    },
    focus: function focus() {
      this.editor.focus();
    },
    onMouseUp: function onMouseUp(event, editor) {
      var position = editor.getCursorPosition();
      var token = editor.session.getTokenAt(position.row, position.column);
      console.log(token);
    },
    onDocumentChanged: function onDocumentChanged() {
      var _this2 = this;

      this.$emit('change', this.editor.getValue(), this.isFirstChange);
      var iterator = new TokenIterator(this.editor.session, 0, 0);
      var lists = this.buildListTree(iterator);
      lists.forEach(function (list) {
        _this2.cleanNumberedList(_this2.editor, list);
      });
      if (this.isFirstChange) {
        this.isFirstChange = false;
        this.editor.session.on('change', __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.debounce(this.onDocumentChanged5s, 5000));
      }
    },


    /**
     * Save document after 5 second without user interaction.
     */
    onDocumentChanged5s: function onDocumentChanged5s() {
      this.$emit('slow-change', this.editor.getValue());
    },
    buildList: function buildList(iterator, list, _line) {
      var line = _line;
      while (iterator.stepForward()) {
        var currentToken = iterator.getCurrentToken();
        var match = /^markup\.list\.(numbered|unnumbered)\.level_(\d+)$/.exec(currentToken.type);
        if (match) {
          var item = {
            line: iterator.getCurrentTokenRow(),
            column: iterator.getCurrentTokenColumn(),
            type: match[1],
            level: parseInt(match[2], 10)
          };
          if (item.level === list.level) {
            list.items.push(item);
            line += 1;
          } else if (item.level === list.level + 1) {
            var sublist = {
              first: item.line,
              level: item.level,
              type: item.type,
              items: [item]
            };
            line = this.buildList(iterator, sublist, line);
            /*eslint-disable */
            list.items[list.items.length - 1].sublist = sublist;
            /*eslint-enable */
          } else {
            iterator.stepBackward();
            break;
          }
        }
      }
      return line + 1;
    },
    buildListTree: function buildListTree(iterator) {
      var lists = [];
      var line = 0;
      var currentList = null;
      while (iterator.stepForward()) {
        var currentToken = iterator.getCurrentToken();
        var match = /^markup\.list\.(numbered|unnumbered)\.level_(\d+)$/.exec(currentToken.type);
        if (match) {
          var item = {
            line: iterator.getCurrentTokenRow(),
            column: iterator.getCurrentTokenColumn(),
            type: match[1],
            level: parseInt(match[2], 10)
          };
          if (item.line > line + 1) {
            // Push the current list to the list array.
            if (currentList) {
              lists.push(currentList);
            }
            // Create new list.
            currentList = {
              first: item.line,
              level: item.level,
              type: item.type,
              items: [item]
            };
            line = item.line;
          } else if (currentList && item.level === currentList.level + 1) {
            // Create sublist.
            var sublist = {
              first: item.line,
              level: item.level,
              type: item.type,
              items: [item]
            };
            line = this.buildList(iterator, sublist, line);
            currentList.items[currentList.items.length - 1].sublist = sublist;
          } else if (currentList && item.level === currentList.level) {
            currentList.items.push(item);
            line = item.line;
          }
        }
      }
      if (currentList) {
        lists.push(currentList);
      }
      return lists;
    },
    cleanNumberedList: function cleanNumberedList(editor, list) {
      /*eslint-disable */
      for (var i in list.items) {
        var item = list.items[i];
        if (list.type === 'numbered') {
          var line = editor.session.getLine(item.line);
          var index = parseInt(i) + 1;
          var new_line = line.replace(/\w*([0-9]+)\./, index + '.');
          if (new_line !== line) {
            var range = new Range(item.line, 0, item.line, line.length);
            editor.session.replace(range, new_line);
          }
        }
        if (item.sublist !== undefined) {
          this.cleanNumberedList(editor, item.sublist);
        }
      }
      /*eslint-enable */
    }
  }
});

/***/ }),

/***/ "k75E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mvFs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarkdownToHtml_vue__ = __webpack_require__("Msg3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_768e2415_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MarkdownToHtml_vue__ = __webpack_require__("XGaa");
function injectStyle (ssrContext) {
  __webpack_require__("k75E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarkdownToHtml_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_768e2415_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MarkdownToHtml_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n3y4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DriveFileListItem__ = __webpack_require__("bTBT");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'driveFileList',

  components: {
    DriveFileListItem: __WEBPACK_IMPORTED_MODULE_1__DriveFileListItem__["a" /* default */]
  },

  data: function data() {
    return {
      refreshStatus: '',
      files: [],
      filter: ''
    };
  },


  computed: {
    filteredFiles: function filteredFiles() {
      var _this = this;

      return this.files.filter(function (file) {
        return file.name.match(_this.checkRegex(_this.filter));
      });
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.refreshStatus = '';
    this.getFiles();
    this.$events.on('file-delete', function (file) {
      var index = -1;
      _this2.files.forEach(function (elt, i) {
        if (elt.id === file.id) {
          index = i;
        }
      });
      if (index >= 0) {
        _this2.files.splice(index, 1);
      }
    });
  },


  methods: {
    checkRegex: function checkRegex(string) {
      try {
        return new RegExp(string);
      } catch (e) {
        return '';
      }
    },
    getFiles: function getFiles() {
      var _this3 = this;

      this.refreshStatus = 'pending';
      var q = "mimeType = 'text/markdown'";
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].googleDrive.files(q, '*').then(function (response) {
        if (response.status !== 200) {
          // @ToDo Do something with errors.
          _this3.refreshStatus = 'error';
        } else if (response.result !== undefined && response.result.files !== undefined) {
          _this3.files = response.result.files;
          _this3.refreshStatus = '';
        }
      });
    },
    refresh: function refresh() {
      this.getFiles();
    },
    create: function create() {
      this.files.push({
        name: '',
        isNew: true
      });
    }
  }
});

/***/ }),

/***/ "pIzI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Ace__ = __webpack_require__("zcyG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MarkdownToHtml__ = __webpack_require__("mvFs");
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'editor',

  data: function data() {
    return {
      /** The file metadata. */
      file: {},

      /** The original value. */
      value: '',

      /** The updated value. */
      currentValue: '',

      remarkableIsVisible: false,

      pendingSave: false
    };
  },


  components: {
    Ace: __WEBPACK_IMPORTED_MODULE_1__Ace__["a" /* default */],
    MarkdownToHtml: __WEBPACK_IMPORTED_MODULE_2__MarkdownToHtml__["a" /* default */]
  },

  mounted: function mounted() {
    var _this = this;

    this.$events.on('edit-file', function (file) {
      _this.file = file;
      var defaultValue = '# ' + _this.file.name;
      if (_this.file.id) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].googleDrive.fileContent(file.id).then(function (response) {
          if (response.status === 200) {
            _this.value = response.body || defaultValue;
          } else {
            console.log(response);
          }
        });
      } else {
        _this.value = defaultValue;
      }
    });

    this.$events.on('file-delete', function (file) {
      if (_this.file.id === file.id || _this.file.randomId === file.randomId) {
        if (_this.$refs.ace.isReady) {
          _this.$refs.ace.destroy();
        }
      }
    });
  },


  methods: {
    onDocumentChanged: function onDocumentChanged(value, isFirstChange) {
      this.currentValue = value;
      if (!isFirstChange) {
        this.pendingSave = true;
        this.$events.emit('editor-pending-save', this.file, this.pendingSave, null);
      }
    },
    saveDocument: function saveDocument() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].googleDrive.saveFile(this.file, this.currentValue).then(function (response) {
        if (response.status === 200) {
          _this2.pendingSave = false;
          // Update id for new file.
          _this2.file.id = response.result.id;
        }
        _this2.$events.emit('editor-pending-save', _this2.file, _this2.pendingSave, response);
      });
    },
    toggleRemarkable: function toggleRemarkable() {
      this.remarkableIsVisible = !this.remarkableIsVisible;
    }
  }
});

/***/ }),

/***/ "rO5K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tJhk":
/***/ (function(module, exports) {

/*eslint-disable */
ace.define("theme/markddrive", ["require", "exports", "module"], function (require, exports, module) {

  exports.isDark = true;
  exports.cssClass = "markddrive";

  // var dom = require("ace/lib/dom");
  // dom.importCssStylsheet("/src/ace_custom/theme-markddrive.css", document);
});
/*eslint-enable */

/***/ }),

/***/ "tzNG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor__ = __webpack_require__("aek+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DriveFileList__ = __webpack_require__("GAZN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__package_json__ = __webpack_require__("7YgM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__package_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',

  components: {
    Editor: __WEBPACK_IMPORTED_MODULE_1__components_Editor__["a" /* default */],
    DriveFileList: __WEBPACK_IMPORTED_MODULE_2__components_DriveFileList__["a" /* default */]
  },

  data: function data() {
    return {
      value: '',
      isSignIn: false,
      currentFile: {},
      basicProfile: {},
      packageInfo: __WEBPACK_IMPORTED_MODULE_3__package_json___default.a
    };
  },


  computed: {
    filename: function filename() {
      if (this.currentFile && this.currentFile.name !== undefined) {
        return ' - ' + this.currentFile.name;
      }
      return '';
    },
    username: function username() {
      try {
        return this.basicProfile.getName();
      } catch (e) {
        return '';
      }
    },
    userImageUrl: function userImageUrl() {
      try {
        return this.basicProfile.getImageUrl();
      } catch (e) {
        return '';
      }
    }
  },

  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].googleDrive.on('gapi.auth2:loaded', function (isSignIn) {
      _this.isSignIn = isSignIn;
      if (isSignIn) {
        _this.basicProfile = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].googleDrive.user.getBasicProfile();
      } else {
        _this.basicProfile = {};
        _this.currentFile = {};
      }
    });
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].googleDrive.on('isSignInChanged', function (newIsSignIn) {
      _this.isSignIn = newIsSignIn;
      if (newIsSignIn) {
        _this.basicProfile = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].googleDrive.user.getBasicProfile();
      } else {
        _this.basicProfile = {};
        _this.currentFile = {};
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$events.on('edit-file', function (file) {
      _this2.currentFile = file;
    });
    this.$events.on('file-delete', function (file) {
      if (_this2.currentFile && _this2.currentFile.id === file.id) {
        _this2.currentFile = {};
      }
    });
  },


  methods: {
    logout: function logout() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].googleDrive.signOut().then(function () {
        _this3.isSignIn = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].googleDrive.isSignIn;
        if (!_this3.isSignIn) {
          _this3.basicProfile = {};
          _this3.currentFile = {};
        }
      });
    },
    login: function login() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].googleDrive.signIn().then(function () {
        _this4.isSignIn = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].googleDrive.isSignIn;
        _this4.basicProfile = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].googleDrive.user.getBasicProfile();
      });
    },
    toggleSideNav: function toggleSideNav() {
      this.$refs.sideNav.toggle();
    },
    openDialog: function openDialog(ref) {
      this.$refs[ref].open();
    },
    closeDialog: function closeDialog(ref) {
      this.$refs[ref].close();
    }
  }
});

/***/ }),

/***/ "zZsU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('md-toolbar', [(_vm.isSignIn) ? [_c('h1', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v("MarkdDrive " + _vm._s(_vm.filename))]), _vm._v(" "), _c('md-button', {
    staticClass: "user-sidenav-toggle md-icon-button",
    on: {
      "click": _vm.toggleSideNav
    }
  }, [_c('md-icon', [_vm._v("account_circle")])], 1)] : [_c('h1', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v("MarkdDrive")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-button",
    on: {
      "click": _vm.login
    }
  }, [_c('md-icon', [_vm._v("face")]), _vm._v(" "), _c('span', [_vm._v("Sign in")])], 1)]], 2), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [(_vm.isSignIn) ? [_c('DriveFileList', {
    staticClass: "file-list"
  }), _vm._v(" "), _c('Editor', {
    attrs: {
      "value": _vm.value
    }
  })] : _vm._e()], 2), _vm._v(" "), (_vm.isSignIn) ? _c('md-sidenav', {
    ref: "sideNav",
    staticClass: "user-sidenav md-right md-fixed"
  }, [_c('md-toolbar', {
    staticClass: "md-large"
  }, [_c('md-avatar', {
    staticClass: "md-large",
    staticStyle: {
      "margin": "16px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.userImageUrl,
      "alt": "People"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v(_vm._s(_vm.username))])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "sidenav-content",
    attrs: {
      "md-column": ""
    }
  }, [_c('md-layout', {
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_c('md-list', {
    staticClass: "user-actions",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('md-list-item', [_c('md-icon', [_vm._v("settings")]), _vm._v(" "), _c('span', [_vm._v("Settings")]), _vm._v(" "), _c('md-list-expand', [_c('md-list', {
    staticClass: "user-actions"
  }, [_c('md-list-item', {
    staticClass: "md-inset"
  }, [_c('md-checkbox', [_vm._v("Debug mode")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-button",
    on: {
      "click": function($event) {
        _vm.openDialog('aboutDialog')
      }
    }
  }, [_c('md-icon', [_vm._v("info_outline")]), _vm._v(" "), _c('span', [_vm._v("About")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-button",
    staticStyle: {
      "flex": "1"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('md-icon', [_vm._v("exit_to_app")]), _vm._v(" "), _c('span', [_vm._v("Sign out")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-dialog', {
    ref: "aboutDialog",
    staticClass: "dialog",
    attrs: {
      "md-open-from": "#about",
      "md-close-to": "#about"
    }
  }, [_c('md-dialog-title', [_vm._v("About MarkdDrive")]), _vm._v(" "), _c('md-dialog-content', [_c('p', {
    staticStyle: {
      "margin-bottom": "42px"
    }
  }, [_vm._v(_vm._s(_vm.packageInfo.description))]), _vm._v(" "), _c('md-list', {
    staticClass: "list"
  }, [_c('md-list-item', [_vm._v("v" + _vm._s(_vm.packageInfo.version))]), _vm._v(" "), _c('md-list-item', [_vm._v("License: " + _vm._s(_vm.packageInfo.license))]), _vm._v(" "), _c('md-list-item', [_c('a', {
    attrs: {
      "href": _vm.packageInfo.homepage,
      "target": "_blank"
    }
  }, [_vm._v("Home page")])]), _vm._v(" "), _c('md-list-item', [_c('a', {
    attrs: {
      "href": _vm.packageInfo.bugs.url,
      "target": "_blank"
    }
  }, [_vm._v("Report a bug")])])], 1)], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary button",
    on: {
      "click": function($event) {
        _vm.closeDialog('aboutDialog')
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zcyG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ace_vue__ = __webpack_require__("j9aK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cf6659a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Ace_vue__ = __webpack_require__("ZaTb");
function injectStyle (ssrContext) {
  __webpack_require__("hFta")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ace_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cf6659a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Ace_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.92c0e12ebedbcd1bf887.js